import File from './file';
import Team from './team';
import TeamMember from './team-member';
import TeamMembers from './team-members';
import User from './user';

const models = {
  User,
  Team,
  File,
  TeamMember,
  TeamMembers,
};

export { File, Team, TeamMember, TeamMembers, User };
export default models;
